import React, { useState } from 'react';
import { Button, Label, Modal, Textarea, TextInput } from 'flowbite-react';
import { useToast } from 'src/context/ToastProvider';
import { useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { set } from 'lodash';
import { useUpdateLeadGen } from 'src/hooks/leadGen.hooks';

type Props = {
    id: string;
    isOpen: boolean;
    onClose: () => void;
    refetch?: () => void;
};

const IsArchivedModal = ({ isOpen, onClose, id, refetch }: Props) => {
    const toast = useToast();
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const { mutate: closedLeadGen, isLoading } = useUpdateLeadGen(
        data => {
            toast({ title: data.message || 'LeadGen Closed successfully', type: 'success' });
            onClose();
            refetch && refetch();
            navigate('/leads-gen');
            queryClient.invalidateQueries('leadGens');
        },
        error => {
            toast({ title: error || 'Error Closing LeadGen', type: 'error' });
        },
    );

    const handleClose = () => {
        closedLeadGen({ id: id, action: 'isArchive' });
    };
    return (
        <Modal show={isOpen} size="xl" onClose={onClose} dismissible>
            <Modal.Header>
                Are you sure to close the lead?
            </Modal.Header>
            <Modal.Body>
                <div className="flex justify-end space-x-4">
                    <Button color="gray" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button color="failure" onClick={handleClose}>
                        Close
                    </Button>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default IsArchivedModal;